import { logger } from "@/helpers/tslog";

export interface CandidateShapeMeta {
  id: string;
  name: string;
  left: number;
  top: number;
  width: number;
  height: number;
  slideId?: string;
}

const TITLE_KEY = "candidateContentTitle";
const SUBTITLE_KEY = "candidateContentSubTitle";
const CLOSEST_GAP_KEY = "candidateContentClosestGap";
export const saveCandidatePlaceholders = (title?: CandidateShapeMeta | null, subTitle?: CandidateShapeMeta | null, closestGap?: number) => {
  try {
    const hasTitle = Boolean(title);
    const hasSubTitle = Boolean(subTitle);
    const titleToStore = hasTitle ? title : {};
    const subTitleToStore = hasTitle && hasSubTitle ? subTitle : {};
    const closestGapToStore = closestGap ? closestGap : 0;

    localStorage.setItem(TITLE_KEY, JSON.stringify(titleToStore));
    localStorage.setItem(SUBTITLE_KEY, JSON.stringify(subTitleToStore));
    localStorage.setItem(CLOSEST_GAP_KEY, JSON.stringify(closestGapToStore));
    logger.info("saveCandidatePlaceholders", {
      hasTitle,
      hasSubTitle: hasTitle && Boolean(subTitle),
    });
  } catch (e) {
    logger.warn("saveCandidatePlaceholders failed", e);
  }
};

export const getCandidatePlaceholders = (): { title: CandidateShapeMeta | Record<string, never>; subTitle: CandidateShapeMeta | Record<string, never>; closestGap: number } => {
  const safeParse = (raw: string | null) => {
    if (!raw) return {};
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  };

  try {
    const title = safeParse(localStorage.getItem(TITLE_KEY));
    const subTitle = safeParse(localStorage.getItem(SUBTITLE_KEY));
    const closestGap = Number(localStorage.getItem(CLOSEST_GAP_KEY));
    return { title, subTitle, closestGap };
  } catch (e) {
    logger.warn("getCandidatePlaceholders failed", e);
    return { title: {}, subTitle: {}, closestGap: 0 };
  }
};

export const clearCandidatePlaceholdersLocalStorage = () => {
  try {
    localStorage.removeItem(TITLE_KEY);
    localStorage.removeItem(SUBTITLE_KEY);
    localStorage.removeItem(CLOSEST_GAP_KEY);
    logger.info("clearCandidatePlaceholdersLocalStorage: removed items");
  } catch (e) {
    logger.warn("clearCandidatePlaceholdersLocalStorage failed", e);
  }
};

export const clearCandidatePlaceholders = () => {
  try {
    localStorage.setItem(TITLE_KEY, JSON.stringify({}));
    localStorage.setItem(SUBTITLE_KEY, JSON.stringify({}));
    localStorage.setItem(CLOSEST_GAP_KEY, JSON.stringify(0));
    logger.info("clearCandidatePlaceholders: set empty objects");
  } catch (e) {
    logger.warn("clearCandidatePlaceholders failed", e);
  }
};


